/**
 * Centralized Driver Filtering Utility
 *
 * Constants and helpers for filtering to real, active drivers.
 * Mirrors the backend logic in backend/app/utils/driver_filters.py.
 */

export const OUTSIDE_CARRIER = "000";
export const ADMIN_DRIVERS = ["99998", "99999", "001"] as const;
export const PLACEHOLDER_DRIVERS = new Set([
  OUTSIDE_CARRIER,
  ...ADMIN_DRIVERS,
]);

/**
 * Check if a driver ID represents a real, active driver.
 * Returns false for outside carriers, admin drivers, and empty values.
 */
export function isRealDriver(
  driverId: string | null | undefined
): boolean {
  return !!driverId && driverId.trim() !== "" && !PLACEHOLDER_DRIVERS.has(driverId);
}
